// Mock data for Fascicolo (Dossier) Panel

export const MOCK_DOSSIER = {
  cuaa: 'IT12345678901',
  legalForm: 'Società Agricola',
  businessName: 'Azienda Agricola Demo S.r.l.',
  representative: 'Marco Rossi',
  officeAddress: {
    street: 'Via Roma 123',
    city: 'Rome',
    postalCode: '00100',
    province: 'RM',
    country: 'Italy',
  },
  payingAgency: 'AGEA - Agenzia per le Erogazioni in Agricoltura',
  openingDate: new Date('2016-03-01'),
  closingDate: null,
  holderType: 'CAA',
  holderCode: 'CAA-IT-0192',
  validationDate: new Date('2024-01-15'),
  taxId: '12345678901',
  vatNumber: 'IT12345678901',
  registryNumber: 'RM-2020-11345',
  inpsCode: 'INPS-AGRI-00321',
  bankAccounts: ['IT60X0542811101000000123456'],
  labor: {
    type: 'Familiare',
    units: 3,
    hours: 4200,
  },
  farmArea: 7.1,
  landInventory: [
    {
      id: 'parcel-001',
      parcelId: 'P01',
      sheetNumber: '14',
      parcelNumber: '107',
      area: 2.4,
      unit: 'ha',
      cropType: 'Durum Wheat',
      status: 'active',
      lastActivity: new Date('2024-11-10'),
      lastActivityType: 'Fertilization - NPK',
      soilType: 'Clay loam',
      irrigationType: 'Drip',
    },
    {
      id: 'parcel-002',
      parcelId: 'P02',
      sheetNumber: '14',
      parcelNumber: '109',
      area: 1.1,
      unit: 'ha',
      cropType: 'Durum Wheat',
      status: 'active',
      lastActivity: new Date('2024-12-01'),
      lastActivityType: 'Pest monitoring',
      soilType: 'Sandy loam',
      irrigationType: 'Sprinkler',
    },
    {
      id: 'parcel-003',
      parcelId: 'P03',
      sheetNumber: '16',
      parcelNumber: '44',
      area: 0.8,
      unit: 'ha',
      cropType: 'Fallow',
      status: 'recovery',
      lastActivity: new Date('2024-09-15'),
      lastActivityType: 'Soil amendment',
      soilType: 'Clay',
      irrigationType: 'None',
    },
    {
      id: 'parcel-004',
      parcelId: 'P04',
      sheetNumber: '16',
      parcelNumber: '45',
      area: 1.5,
      unit: 'ha',
      cropType: 'Olive Trees',
      status: 'active',
      lastActivity: new Date('2024-11-20'),
      lastActivityType: 'Pruning',
      soilType: 'Loam',
      irrigationType: 'Drip',
    },
  ],
  livestock: null, // null for plant-based farms
  buildings: [
    {
      id: 'building-001',
      type: 'Warehouse',
      area: 500,
      unit: 'm²',
      purpose: 'Storage of agricultural products',
      location: 'Main farm area',
      constructionYear: 2010,
    },
    {
      id: 'building-002',
      type: 'Greenhouse',
      area: 200,
      unit: 'm²',
      purpose: 'Seedling production',
      location: 'South side of property',
      constructionYear: 2018,
    },
    {
      id: 'building-003',
      type: 'Office',
      area: 80,
      unit: 'm²',
      purpose: 'Administrative office',
      location: 'Main farm area',
      constructionYear: 2015,
    },
  ],
  means: [
    {
      id: 'means-001',
      type: 'Tractor',
      quantity: 2,
      condition: 'Good',
      brand: 'John Deere',
      model: '6120M',
      year: 2020,
    },
    {
      id: 'means-002',
      type: 'Harvester',
      quantity: 1,
      condition: 'Excellent',
      brand: 'New Holland',
      model: 'CR8.90',
      year: 2022,
    },
    {
      id: 'means-003',
      type: 'Irrigation System',
      quantity: 1,
      condition: 'Good',
      brand: 'Rain Bird',
      model: 'Drip System',
      year: 2019,
    },
    {
      id: 'means-004',
      type: 'Seeder',
      quantity: 1,
      condition: 'Good',
      brand: 'Kuhn',
      model: 'Espro 3000',
      year: 2021,
    },
  ],
};

// Mock dossier for animal-based farm
export const MOCK_DOSSIER_ANIMALS = {
  ...MOCK_DOSSIER,
  livestock: [
    {
      id: 'livestock-001',
      type: 'Bovini',
      category: 'Dairy Cattle',
      count: 45,
      breed: 'Holstein Friesian',
      location: 'Barn A',
      averageAge: 4.5,
      notes: 'Main dairy herd',
    },
    {
      id: 'livestock-002',
      type: 'Suini',
      category: 'Pigs',
      count: 120,
      breed: 'Large White',
      location: 'Pen B',
      averageAge: 1.2,
      notes: 'Breeding stock',
    },
    {
      id: 'livestock-003',
      type: 'Ovini',
      category: 'Sheep',
      count: 80,
      breed: 'Sarda',
      location: 'Pasture C',
      averageAge: 3.0,
      notes: 'Grazing flock',
    },
  ],
};

// Helper function to get dossier by report ID
export function getDossierByReportId(reportId, reportType = 'plants') {
  // In production, this would fetch from API
  if (reportType === 'animals' || reportType === 'livestock') {
    return MOCK_DOSSIER_ANIMALS;
  }
  return MOCK_DOSSIER;
}

// Helper function to calculate total land area
export function calculateTotalLandArea(landInventory) {
  return landInventory.reduce((total, parcel) => total + parcel.area, 0);
}

// Helper function to format address
export function formatAddress(address) {
  if (!address) return 'N/A';
  const parts = [
    address.street,
    address.city,
    address.postalCode,
    address.province,
    address.country,
  ].filter(Boolean);
  return parts.join(', ');
}


